// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./clients/web/src/stylesheets/body/collectionList.styl
// module id = 241
// module chunks = 0